import { AppRolesList, CatDocumentList, NavItemDataProps, RepositoryApiSubTypes, SelectType } from "../types"

export const APP_TITLE = "ApiDocs Procesar"
export const APP_HELP_TITLE_MAXLENGTH = 40
export const APP_API_NUMBER_BRANDS = process.env.NODE_ENV === 'test' ? 1 : 3

/**
 * HTTP request
 */
export const loginConfig = {
    baseURL: `${process.env.REACT_APP_URL_LOGIN}`,
    timeout: 60000 * 5,
    headers: { "Content-Type": 'application/json;charset=UTF-8' }
}

export const swaggerConfig = {
    ...loginConfig,
    baseURL: `${process.env.REACT_APP_URL_SWAGGER}`
}

export const sartokenConfig = {
    ...loginConfig,
    baseURL: `${process.env.REACT_APP_URL_SARTOKEN}`
}

export const requestConfig = {
    ...loginConfig,
    baseURL: `${process.env.REACT_APP_URL_PORTAL_API}`
}

export const requestConfigForm = {
    ...requestConfig,
    headers: { "Content-Type": 'multipart/form-data' }
}

/**
 * Routes
 */
export const ROLES: AppRolesList = {
    ADMIN: 1,
    PROVIDER: 2,
    AFORE: 3,
    INSTITUTOS: 4,
    INTERNO: 5,
    PEMEX: 6
}

const URLAPP_ROOT = '/dashboard'
const URLAPP_WORKSPACE_ROOT = `${URLAPP_ROOT}/workspace`
const URLAPP_APIDOC_ROOT = `${URLAPP_ROOT}/apidoc`
const URLAPP_SDK_ROOT = `${URLAPP_ROOT}/mobile`
const URLAPP_ACCESSROL_ROOT = `${URLAPP_ROOT}/accesos`
const URLAPP_RESOURCES_ROOT = `${URLAPP_ROOT}/recursos`
const URLAPP_BLOG_ROOT = `${URLAPP_ROOT}/blog`
const URLAPP_SARENV_ROOT = `${URLAPP_ROOT}/ambientaciones`
const URLAPP_TICKET_ROOT = `${URLAPP_ROOT}/tickets`

export const URLAPP = {
    root: URLAPP_ROOT,
    start: `${URLAPP_ROOT}/inicio`,
    profile: `${URLAPP_ROOT}/perfil`,
    pageCredentials: `${URLAPP_ROOT}/credenciales`,
    workspace: URLAPP_WORKSPACE_ROOT,
    workspaceRepository: `${URLAPP_WORKSPACE_ROOT}/repositorio`,
    workspaceCatalog: `${URLAPP_WORKSPACE_ROOT}/catalogos`,
    workspaceTickets: `${URLAPP_WORKSPACE_ROOT}/tickets`,
    apidoc: URLAPP_APIDOC_ROOT,
    apidocGroup: `${URLAPP_APIDOC_ROOT}/grupo`,
    apidocRest: `${URLAPP_APIDOC_ROOT}/rest`,
    apidocRestAdmin: `${URLAPP_APIDOC_ROOT}/rest/administracion`,
    apidocRestDoc: `${URLAPP_APIDOC_ROOT}/rest/documento`,
    apidocSoap: `${URLAPP_APIDOC_ROOT}/soap`,
    apidocSoapAdmin: `${URLAPP_APIDOC_ROOT}/soap/administracion`,
    apidocSoapDoc: `${URLAPP_APIDOC_ROOT}/soap/documento`,
    mobile: URLAPP_SDK_ROOT,
    mobileSdkAdmin: `${URLAPP_SDK_ROOT}/administracion`,
    mobileSdkList: `${URLAPP_SDK_ROOT}/sdk`,
    mobileTools: `${URLAPP_SDK_ROOT}/herramientas`,
    accessRol: URLAPP_ACCESSROL_ROOT,
    accessMenu: `${URLAPP_ACCESSROL_ROOT}/roles`,
    accessResources: `${URLAPP_ACCESSROL_ROOT}/recursos`,
    linkedResources: URLAPP_RESOURCES_ROOT,
    linkedResourcesGroup: `${URLAPP_RESOURCES_ROOT}/grupo`,
    blog: URLAPP_BLOG_ROOT,
    blogAdmin: `${URLAPP_BLOG_ROOT}/administracion`,
    blogList: `${URLAPP_BLOG_ROOT}/entradas`,
    sarenv: URLAPP_SARENV_ROOT,
    sarenvLogbook: `${URLAPP_SARENV_ROOT}/bitacora`,
    sarenvProfile: `${URLAPP_SARENV_ROOT}/perfiles`,
    sarenvProfileIndependiente: `${URLAPP_SARENV_ROOT}/perfiles/independiente`,
    sarenvProfileImssPuro: `${URLAPP_SARENV_ROOT}/perfiles/imss-puro`,
    sarenvProfileImssRegistrado: `${URLAPP_SARENV_ROOT}/perfiles/registrado-imss`,
    sarenvProfileIsssteRegistrado: `${URLAPP_SARENV_ROOT}/perfiles/registrado-issste`,
    sarenvProfileMixto: `${URLAPP_SARENV_ROOT}/perfiles/registrado-mixto`,
    sarenvProfileAsignado: `${URLAPP_SARENV_ROOT}/perfiles/registrado-asignado`,
    sarenvProfileAvanzado: `${URLAPP_SARENV_ROOT}/perfiles/avanzado`,
    sarenvChangeAfore: `${URLAPP_SARENV_ROOT}/perfiles/cambio-afore`,
    tickets: `${URLAPP_TICKET_ROOT}`,
} as const;

export const DEFAULT_MENU: NavItemDataProps[] = [
    {
        id: 0,
        label: 'ApiDocs',
        icon: 'passport',
        path: URLAPP_APIDOC_ROOT,
        breadcrumbs: []
    }
]

export const URLQUERY = {
    search: 'busqueda',
    group: 'grupo',
    target: 'target',
    tab: 'tab',
    normative: 'normativo',
    status: 'estado',
    help: 'ayuda',
    readId: 'readId'
} as const;

/**
 * Files
 */
export const MB_VAL = 1048576;

export const FILE_TEXT_IFRAME = ['html']

export const FILE_CONTENT = {
    img: ['jpg', 'png', 'jpeg', 'svg', 'gif', 'webp'],
    video: ['webm', 'mp4'],
    text: ['txt', 'java', 'css', 'yml', 'csv', 'json', 'sql', ...FILE_TEXT_IFRAME],
    xml: ['xml', 'wsdl', 'xsd'],
    excel: ['xlsx'],
    application: ['pdf']
}

/**
 * Filters
 */
export const NORMATIVE_FILTER = [
    { label: 'Normativo', value: 1 },
    { label: 'Beta', value: 0 }
]

export const SORT_OPTIONS = [
    { label: 'Nombre', value: 'name' },
    { label: 'Fecha de actualización', value: 'updatedAt' },
    { label: 'Fecha de creación', value: 'createdAt' },
    { label: 'TIpos de archivos', value: 'fileType' }
]

export const CATALOG_ACTIVE = [
    { value: 1, label: 'Activo' },
    { value: 0, label: 'Inactivo' }
] as const;

export const SDK_SUBTYPES: RepositoryApiSubTypes = 'MBL'
export const API_SUBTYPES: RepositoryApiSubTypes = 'API'
export const SOAP_SUBTYPES: RepositoryApiSubTypes = 'SOAP'
export const RECV_SUBTYPES: RepositoryApiSubTypes = 'RECV'

export const MOBILE_SDK_ARTIFACT = 'SDK'
export const MOBILE_DOC_ARTIFACT = 'DOC'
export const REFDOC_ARTIFACT = 'REFDOC'
export const SWAGGER_ARTIFACT = 'SWAGGER'
export const LINKS_ARTIFACT = [REFDOC_ARTIFACT, SWAGGER_ARTIFACT];

export const PAGINATOR_OPTIONS = [5, 10, 15]

export const CATALOG_BASE = 'BASE'

export const ALL_VALUES = '*'

export const HTML_ID_DOCUMENTATION_PAGE = 'page-document'

export const logbookDaysList: SelectType[] = [2, 5, 10, 15].map(n => ({ value: n, label: `${n} días` }))

export const GA_EVENTS = [
    'event_access',
    'event_help',
    'event_rest_service',
    'event_artifact',
    'event_reject',
    'event_env_request',
    'event_env_response'
] as const;


export const CAT_DOCUMENTS: CatDocumentList = {
    selfie: [
        {
            name: 'Selfie', documents: [
                { code: '01', icon: 'user', label: 'Selfie' }
            ]
        }],
    idDocument: [
        {
            name: 'Credencial de Elector',
            documents: [
                { code: '02', icon: 'id-card', label: 'Frente' },
                { code: '03', icon: 'credit-card', label: 'Reverso' }
            ]
        },
        {
            name: 'Pasaporte',
            documents: [
                { code: '04', icon: 'id-card', label: 'Frente' }
            ]
        },
        {
            name: 'Matrícula Consular',
            documents: [
                { code: '05', icon: 'id-card', label: 'Frente' },
                { code: '09', icon: 'credit-card', label: 'Reverso' }
            ]
        }
    ],
    additional: [
        {
            name: 'Acta de nacimiento',
            documents: [
                { code: '08', icon: 'file-invoice', label: 'Acta de nacimiento' }
            ]
        },
        {
            name: 'Comprobante de domicilio',
            documents: [
                { code: '11', icon: 'house-chimney', label: 'Comprobante de domicilio' },
                { code: '13', icon: 'baby', label: 'Constancia de la CURP' }
            ]
        }
    ]
} as const